import React, { Component } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./About.css";

// State / Zonal contacts in Nigeria
const nigeriaContacts = [
  { state: "Ekiti", name: "Sis. Blessing Omorege", phone: "08035736054" },
  { state: "Lagos", name: "Bro. Opeyemi Ojo", phone: "08062943337" },
  { state: "Ogun", name: "Bro. Wole Adigun", phone: "07064699041" },
  { state: "Oyo", name: "Dr. Olufemi AyanfeOluwa", phone: "08075137957" },
  { state: "Osun", name: "Pastor Ayo Okelana", phone: "08055459052" },
  { state: "Ondo", name: "Engr. Ayobami Adedokun", phone: "08068118888" },
  { state: "Abuja", name: "Bro. William Egegie", phone: "07033130378" },
  { state: "Plateau", name: "Bro. Michael Bulkaam", phone: "08164253018" },
  { state: "Nassarawa", name: "Bro. Timothy Babadogo", phone: "08035093839" },
  { state: "Kwara", name: "Dr. John Decampus", phone: "08038296550" },
  { state: "Northern Liaison Officer", name: "Bro. Seun Bankole", phone: "08037451485" },
  { state: "Southwest Liaison Office", name: "Bro. Taiwo Babajide", phone: "08069046644" },
  { state: "Central Office", name: "Dr. Peter Olanrewaju", phone: "08066372188" },
  { state: "Central Coordinator", name: "Dr. Olugbenga AdeOluwa", phone: "08035709365" },
];

// International contacts
const internationalContacts = [
  { country: "Benin", name: "Rev. Michael Okwara", email: "pastormichael03@yahoo.ca" },
  { country: "South Africa", name: "Dr. Adejoke Olufemi", email: "jokephemmy22@yahoo.com" },
  { country: "Ghana", name: "Kweku Enyan Arthur", email: "sirarthur9@yahoo.com" },
  { country: "Europe", name: "Mrs. Moji Odunayo", email: "blessedmoji@yahoo.com" },
];

const CORE_VALUES = [
  { letter: "A", title: "Exemplary Christian Life", verse: "Matthew 5:14", text: "Ye are the light of the world. A city that is set on a hill cannot be hid." },
  { letter: "B", title: "Professionalism", verse: "Proverbs 22:29", text: "Seest thou a man diligent in his business? He shall stand before kings; he shall not stand before mean men." },
  { letter: "C", title: "Dynamism in Christian Missions", verse: "Matthew 28:19", text: "Go ye therefore, and teach all nations, baptizing them in the name of the Father, and of the Son, and of the Holy Ghost." },
];

export default class About extends Component {
  render() {
    // Contact form target
    const contactEmail = "centraloffice@fsmission.org";

    return (
      <div className="App">
        <Header />

        {/* ============ HERO ============ */}
        <section className="fsm-about-hero">
          <div className="fsm-about-hero-inner container">
            <span className="fsm-eyebrow">About Us</span>
            <h1>Foundation for Student Mission</h1>
            <p>
              Christian professionals mobilizing and equipping Christian
              students for missions.
            </p>
          </div>
        </section>

        {/* ============ VISION & GENESIS ============ */}
        <section className="fsm-about-section fsm-vision">
          <div className="container">
            <div className="fsm-vision-grid">
              <div className="fsm-vision-text">
                <span className="fsm-eyebrow fsm-eyebrow-dark">Our Story</span>
                <h2>The Vision and the Genesis</h2>

                <p>
                  The Foundation for Student Mission (FSM) is a network of
                  individuals (students and non-students from all walks of
                  life) and corporate organizations (Churches and mission
                  agencies) focusing on mobilising and equipping Christian
                  students and youths as workforce for missions of the body of
                  Christ.
                </p>

                <p>
                  The organisation has two arms: <strong>Student Mission Club
                  (SMC)</strong> — the student arm — and <strong>The Wise
                  League (TWL)</strong> — the non-student arm. FSM partners
                  with other mission agencies, mission-oriented churches, and
                  Christian student fellowships or campus groups in her
                  regular activities.
                </p>

                <p>
                  The organisation was inaugurated at the University of
                  Agriculture Abeokuta, Nigeria (now Federal University of
                  Agriculture Abeokuta) on <strong>May 20, 1995</strong>. It is
                  now spread across many cities with institutions of higher
                  learning within and outside of Nigeria. To the glory of God,
                  some former student members of FSM are currently serving as
                  missionaries with different organisations within and outside
                  Nigeria, while others hold the fort in other aspects of
                  missions in their churches or mission agencies.
                </p>

                <p>
                  We expect that as students become exposed to multiple
                  mission works, they will find it easier to participate in
                  any of them after graduation.
                </p>
              </div>

              <div className="fsm-vision-stats">
                <div className="fsm-vision-stat">
                  <div className="fsm-vision-stat-value">30+</div>
                  <div className="fsm-vision-stat-label">Years of Ministry</div>
                </div>
                <div className="fsm-vision-stat">
                  <div className="fsm-vision-stat-value">50+</div>
                  <div className="fsm-vision-stat-label">Campus Chapters</div>
                </div>
                <div className="fsm-vision-stat">
                  <div className="fsm-vision-stat-value">5+</div>
                  <div className="fsm-vision-stat-label">Countries</div>
                </div>
                <div className="fsm-vision-stat">
                  <div className="fsm-vision-stat-value">1995</div>
                  <div className="fsm-vision-stat-label">Founded</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ VISION & CORE VALUES ============ */}
        <section className="fsm-about-section fsm-about-values">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">Our Foundation</span>
              <h2>Vision &amp; Core Values</h2>
            </div>

            <div className="fsm-about-values-grid">
              <div className="fsm-about-card">
                <h3>Our Vision &amp; Objective</h3>
                <p>
                  Teaching, encouraging, convincing and involving every
                  Christian student in expanding God's Kingdom through missions
                  to the unreached in their generations.
                </p>
                <p>
                  We do such by:
                </p>
                <ol className="fsm-values-list">
                  <li>
                    Mobilizing and equipping Christian students for missions
                  </li>
                  <li>
                    Sustenance of missionary zeal of students on campuses and
                    the non-student members in cities where the campuses are
                    located
                  </li>
                  <li>
                    Acting as support base for many mission agencies and
                    mission-oriented churches, raising resources for mission
                    works
                  </li>
                </ol>
              </div>

              <div className="fsm-about-card">
                <h3>Our Core Values</h3>
                <div className="fsm-core-values">
                  {CORE_VALUES.map((v) => (
                    <div className="fsm-core-value" key={v.letter}>
                      <div className="fsm-core-value-badge">{v.letter}</div>
                      <div className="fsm-core-value-body">
                        <h4>{v.title}</h4>
                        <span className="fsm-core-value-verse">{v.verse}</span>
                        <p>{v.text}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ============ MEMBERSHIP ============ */}
        <section className="fsm-about-section fsm-membership">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">Who We Are</span>
              <h2>Membership</h2>
              <p>
                Foundation for Student Mission membership cuts across many
                Christian fellowships and denominations. Members are bound
                together by a burning desire of seeing the whole world
                evangelized, starting from their 'Jerusalems'.
              </p>
            </div>

            <div className="fsm-membership-grid">
              <div className="fsm-membership-card">
                <div className="fsm-membership-icon">SMC</div>
                <h3>Student Mission Club</h3>
                <p>
                  The student arm of FSM — a community of Christian students
                  on campuses who are passionate about missions and are being
                  trained, equipped and mobilized to reach their generation.
                </p>
              </div>

              <div className="fsm-membership-card">
                <div className="fsm-membership-icon">TWL</div>
                <h3>The Wise League</h3>
                <p>
                  The non-student arm — Christian professionals from
                  different mission agencies and mission-oriented churches
                  who act as facilitators for student-members in specific
                  areas of missions.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ============ CONTACTS IN NIGERIA ============ */}
        <section className="fsm-about-section fsm-contacts">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">Reach Us</span>
              <h2>State / Zonal Contacts in Nigeria</h2>
            </div>

            <div className="fsm-table-wrap">
              <table className="fsm-table">
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}>#</th>
                    <th>State / Zone</th>
                    <th>Name</th>
                    <th>Phone Number</th>
                  </tr>
                </thead>
                <tbody>
                  {nigeriaContacts.map((c, i) => (
                    <tr key={c.state}>
                      <td>{String(i + 1).padStart(2, "0")}</td>
                      <td><strong>{c.state}</strong></td>
                      <td>{c.name}</td>
                      <td>
                        <a href={`tel:${c.phone}`} className="fsm-table-link">
                          {c.phone}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="fsm-section-header" style={{ marginTop: 80 }}>
              <h2>Contacts Outside Nigeria</h2>
            </div>

            <div className="fsm-table-wrap">
              <table className="fsm-table">
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}>#</th>
                    <th>Country</th>
                    <th>Name</th>
                    <th>Email</th>
                  </tr>
                </thead>
                <tbody>
                  {internationalContacts.map((c, i) => (
                    <tr key={c.country}>
                      <td>{String(i + 1).padStart(2, "0")}</td>
                      <td><strong>{c.country}</strong></td>
                      <td>{c.name}</td>
                      <td>
                        <a
                          href={`mailto:${c.email}`}
                          className="fsm-table-link"
                        >
                          {c.email}
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>

        {/* ============ LOCATION & CONTACT ============ */}
        <section className="fsm-about-section fsm-contact">
          <div className="container">
            <div className="fsm-section-header">
              <span className="fsm-eyebrow fsm-eyebrow-dark">Contact Us</span>
              <h2>Get in Touch</h2>
              <p>
                Reach the central office or visit us in person. We'd love to
                hear from you.
              </p>
            </div>

            <div className="fsm-contact-grid">
              <div className="fsm-contact-cards">
                <div className="fsm-contact-card">
                  <div className="fsm-contact-icon">📍</div>
                  <div>
                    <h4>Address</h4>
                    <p>
                      First Floor, Right Wing, No 78/80, beside Elim Plaza.
                      Opp U.I 2nd Gate, Oyo Rd. Ibadan, Oyo State, Nigeria.
                    </p>
                  </div>
                </div>

                <div className="fsm-contact-card">
                  <div className="fsm-contact-icon">📞</div>
                  <div>
                    <h4>Phone</h4>
                    <p>
                      <a href="tel:+2348035709365" className="fsm-table-link">
                        +234 803 570 9365
                      </a>
                    </p>
                    <p className="fsm-contact-hours">Mon – Fri: 9am – 5pm</p>
                  </div>
                </div>

                <div className="fsm-contact-card">
                  <div className="fsm-contact-icon">✉️</div>
                  <div>
                    <h4>Email</h4>
                    <p>
                      <a
                        href="mailto:centraloffice@fsmission.org"
                        className="fsm-table-link"
                      >
                        centraloffice@fsmission.org
                      </a>
                    </p>
                  </div>
                </div>

                <a
                  href="https://www.google.com/maps/search/?api=1&query=7.451696,3.907335"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fsm-btn fsm-btn-primary fsm-btn-block"
                  style={{ marginTop: 8 }}
                >
                  Get Directions
                </a>
              </div>

              <div className="fsm-contact-form-wrap">
                <h3>Send Us a Message</h3>
                <p className="fsm-contact-form-note">
                  Submitting this form will open your email app with a
                  pre-filled message to our central office.
                </p>

                <form
                  className="fsm-contact-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    const data = new FormData(e.target);
                    const subject = data.get("subject") || "Website Enquiry";
                    const name = data.get("name") || "";
                    const email = data.get("email") || "";
                    const message = data.get("message") || "";
                    const body = `Name: ${name}%0D%0AEmail: ${email}%0D%0A%0D%0A${message}`;
                    window.location.href = `mailto:${contactEmail}?subject=${encodeURIComponent(
                      subject
                    )}&body=${body}`;
                  }}
                >
                  <div className="fsm-form-group">
                    <input
                      type="text"
                      name="name"
                      className="fsm-input"
                      placeholder="Your name"
                      required
                    />
                  </div>
                  <div className="fsm-form-group">
                    <input
                      type="email"
                      name="email"
                      className="fsm-input"
                      placeholder="Your email"
                      required
                    />
                  </div>
                  <div className="fsm-form-group">
                    <input
                      type="text"
                      name="subject"
                      className="fsm-input"
                      placeholder="Subject"
                    />
                  </div>
                  <div className="fsm-form-group">
                    <textarea
                      name="message"
                      className="fsm-input"
                      placeholder="Your message"
                      rows="5"
                      required
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="fsm-btn fsm-btn-primary fsm-btn-block"
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}